export class ContentLogin {
  id: any;
  label: any;
  loginLabel: any;
  loginLink: any;
  loginNewWindow: any;
  loginTooltipLabel: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['rightnavLabel']) {
        this.loginLabel = contentjson['rightnavLabel'];
      }
      if (contentjson['rightnavLink']) {
        this.loginLink = contentjson['rightnavLink'];
      }
      if (contentjson['rightnavopeninnewTab']) {
        this.loginNewWindow = contentjson['rightnavopeninnewTab'];
      }
      if (contentjson['loginTooltipLabel']) {
        this.loginTooltipLabel = contentjson['loginTooltipLabel'];
      }
    }
  }
}
